import './index.scss';
import { encryptSecret } from '@/utils';
import { getMediaKey } from '@/reportmedia';
import { getQueryString, getQueryStringNoDecode } from '@/sem2';

let callback =
  getQueryStringNoDecode('clickid') ||
  getQueryStringNoDecode('callback') ||
  getQueryStringNoDecode('uctrackid') ||
  getQueryStringNoDecode('bd_vid') ||
  getQueryStringNoDecode('qz_gdt') ||
  getQueryStringNoDecode('requestid') ||
  getQueryStringNoDecode('request_id') ||
  getQueryStringNoDecode('callback_param') ||
  getQueryStringNoDecode('gdt_vid') || // 微信
  'callbackDefault';

let mediaKey = '';
const hashId = getQueryString('hashId') || 'hashIdDefault';

let qrcodeId = ['#qrcode', '#dialogQRcode', '#teacher-qrcode'];
let qrcodeSize = {
  '#qrcode': {
    width: 210,
    height: 210
  },
  '#dialogQRcode': {
    width: 200,
    height: 200
  },
  '#teacher-qrcode': {
    width: 200,
    height: 200
  }
};
let customWidth = true;

(async () => {
  console.log('ready 事件回调开始执行');
  try {
    const { CurTime, Nonce, CheckSum } = encryptSecret();
    const { code, data } = await getMediaKey(CurTime, Nonce, CheckSum, {
      hashId,
      callback,
      link: encodeURIComponent(window.location.href)
    });

    mediaKey = data.mediaKey;
    const baseLink = 'https://cssupport.17biying.net/link/info';
    const link = `${baseLink}?hashId=${hashId}&mediaKey=${mediaKey}`;

    qrcodeId.forEach((name) => {
      const qrob = customWidth ? qrcodeSize[name] : { width: 256, height: 256 };
      jQuery(name).qrcode({ ...qrob, text: link });
    });
    startPolling();
  } catch (error) {
    console.error('发生错误:', error);
  }
  setTimeout(() => {
    $('.dialog-container-mask').fadeIn();
  }, 15000);
})();

// 状态管理变量
let pollingStarted = false;
let dialogShow = false;
let isMaskVisible = false;
let isMask1Visible = false;

function startPolling() {
  let elapsedTime = 0;
  let intervalId;

  function sendRequest() {
    $.ajax({
      url: 'https://cssupport.17biying.net/api/v1/slink/media-key-status',
      method: 'POST',
      data: { mediaKey },
      success: function (response) {
        const dialogImgBox = document.querySelector('.dialog-img-box');
        if (response.data.status === 17) {
          $('#dialogQRcode').hide();
          $('.code-title').hide();
          $('.dialog-container-mask').fadeIn();
          dialogImgBox.style.backgroundImage =
            "url('https://upload.mbimc.com/production/ad-tg-template/yd10855/10855dialog-bg-1.png')";
        } else if (response.data.status === 14) {
          dialogImgBox.style.backgroundImage =
            "url('https://upload.mbimc.com/production/ad-tg-template/yd10855/10855dialog-bg-2.png')";
          $('.download-btn').show();
          $('.download-btn')
            .off('click')
            .on('click', (e) => {
              e.preventDefault();
              const urlParams = new URLSearchParams(window.location.search);
              const requestParams = { mediaKey };
              urlParams.forEach((value, key) => {
                requestParams[key] = value;
              });
              const paramStr = new URLSearchParams(requestParams).toString();
              const requestUrl = `https://cssupport.17biying.net/api/v1/qr/app-file?${paramStr}`;

              $.ajax({
                url: requestUrl,
                method: 'GET',
                dataType: 'json',
                success: function (res) {
                  if (res.code === 200 && res.data?.downloadUrl) {
                    const link = document.createElement('a');
                    link.href = res.data.downloadUrl;
                    const fileName = res.data.downloadUrl.split('/').pop() || 'app.exe';
                    link.download = fileName;
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  } else {
                    console.error('未获取到有效下载地址', res);
                  }
                },
                error: function (err) {
                  console.error('获取下载地址失败', err);
                }
              });
            });
        }
      }
    });
  }

  intervalId = setInterval(() => {
    elapsedTime++;
    sendRequest();

    if (elapsedTime === 180) {
      clearInterval(intervalId);
      intervalId = setInterval(() => {
        elapsedTime += 10;
        sendRequest();
        if (elapsedTime >= 600) {
          clearInterval(intervalId);
          console.log('轮询结束');
        }
      }, 10000);
    }
  }, 1000);
}

$('.dialog-container-mask').on('click', (e) => {
  if (e.target === e.currentTarget) {
    $('.dialog-container-mask').fadeOut();
  }
});

$('.get-btn').on('click', (e) => {
  if (e.target === e.currentTarget) {
    $('.dialog-container-mask').fadeIn();
  }
});

function handleScroll() {
  $(document).scroll(function () {
    const scrollHeight = $(document).scrollTop();
    if (scrollHeight > 600) {
      $('.right-popup').fadeIn();
    } else {
      $('.right-popup').fadeOut();
    }
    if (scrollHeight > 200) {
      $('.bottom-con').fadeIn();
    } else {
      $('.bottom-con').fadeOut();
    }
  });
}

handleScroll();

// 等待 DOM 完全加载后再初始化所有 Swiper
$(document).ready(function () {
  // 初始化 part2 的主轮播
  if ($('.swiper-container').length > 0) {
    const mainSwiper = new Swiper('.swiper-container', {
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      initialSlide: 1,
      speed: 500,
      observer: true,
      observeParents: true
    });

    mainSwiper.on('slideChange', function () {
      const activeIndex = this.realIndex; // 使用 realIndex 而不是 activeIndex
      $('.goToSlide').removeClass('active');
      $('.goToSlide').each(function (index) {
        if (index === activeIndex) {
          $(this).addClass('active');
        }
      });
    });

    $('.btn0, .btn1, .btn2, .btn3').hover(
      function () {
        mainSwiper.autoplay.stop();
        const index = $(this).index();
        mainSwiper.slideToLoop(index, 300, false); // 使用 slideToLoop 代替 slideTo
      },
      function () {
        mainSwiper.autoplay.start();
      }
    );

    $('.goToSlide').eq(0).addClass('active');
  }

  // 初始化 part5 的 Swiper - 使用正确的选择器
  if ($('.swiper-container1').length > 0) {
    // 确保容器有正确的样式
    $('.swiper-container1').css({
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      position: 'relative'
    });

    // 确保 .swiper-wrapper 存在，如果不存在则添加
    if ($('.swiper-container1 .swiper-wrapper').length === 0) {
      $('.swiper-container1').html('<div class="swiper-wrapper"></div>');
      // 将原有的 slides 移动到新的 wrapper 中
      $('.part5-swiper-slide').each(function () {
        $('.swiper-container1 .swiper-wrapper').append(this);
      });
    }

    const part5Swiper = new Swiper('.swiper-container1', {
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 500,
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      on: {
        init: function () {
          console.log('Part5 Swiper initialized successfully');
          this.update();
        },
        slideChange: function () {
          console.log('Part5 Slide changed to:', this.realIndex);
        }
      }
    });

    // 鼠标悬停控制
    $('.swiper-container1').hover(
      function () {
        part5Swiper.autoplay.stop();
      },
      function () {
        part5Swiper.autoplay.start();
      }
    );

    // 图片加载完成后更新 Swiper
    $('.part5-swiper-slide img').on('load', function () {
      part5Swiper.update();
    });
  }
});

// 添加窗口大小改变时的处理
window.addEventListener('resize', function () {
  setTimeout(function () {
    if ($('.swiper-container').length > 0 && $('.swiper-container')[0].swiper) {
      $('.swiper-container')[0].swiper.update();
    }
    if ($('.swiper-container1').length > 0 && $('.swiper-container1')[0].swiper) {
      $('.swiper-container1')[0].swiper.update();
    }
  }, 100);
});
